import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_CONFIG_API, // e.g. http://localhost:5000
    // baseURL: 'http://localhost:3001'
});

// Request interceptor adds token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        console.log("Attaching token to request:", token);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor saves refreshed token
api.interceptors.response.use(
    (response) => {
        console.log("✅ Response interceptor fired");
        console.log("Response data:", response);
        return response.data;
    },
    (error) => {
        console.error("❌ Error interceptor fired", error);
        return Promise.reject(error);
    }
);


export default api;
